import React, { useState, useEffect } from "react";
import EditRoles from "./EditRoles";
import Swal from "sweetalert2";
import { MdDelete, MdEdit } from "react-icons/md";
import { FaUserLock } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getTenant,deleteRole } from "../../../redux/roles/rolesSlice";
import Cookies from "js-cookie";
import Loading from "../../../Components/Common/Loading";
import toast from "react-hot-toast";

const RolesTd = () => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { tenant, loading, error } = useSelector((state) => state.tenant);

  useEffect(() => {
    const tenantId = Cookies.get("tenantId");

    if (tenantId && !tenant) {
      dispatch(getTenant(tenantId));
    }
  }, [dispatch, tenant]);

  const handleAssign = (roleId) => {
    navigate(`/iam/roles/adminPermission?role_id=${roleId}`);
  };

  const handleEditClick = (role) => {
    setSelectedRole(role);
    setShowEditForm(true);
  };

  const handleDeleteClick = (roleId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1769d1",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteRole(roleId));
        Swal.fire({
          title: "Deleted!",
          text: "The role has been deleted successfully.",
          icon: "success",
          confirmButtonColor: "#1769d1"
        });
      }
    });
  };

  const handleSave = (updatedRole) => {
    console.log("Updated role:", updatedRole);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  if (loading) {
    return (
      <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50">
        <Loading size="12" color="brand-500" />
      </div>
    );
  }

  if (error === "failed") {
    return toast.error(error);
  }

  return (
    <>
      <EditRoles
        show={showEditForm}
        onClose={() => setShowEditForm(false)}
        role={selectedRole}
        onSave={handleSave}
        setSelectedRole={setSelectedRole}
      />

      {tenant &&
        tenant.roles &&
        tenant.roles.map((item, index) => (
          <tr
            key={item.id || index}
            className="hover:bg-gray-100 bg-gray-50 border border-gray-300 hover:shadow-lg transition duration-300 ease-in-out cursor-pointer "
          >
            <td className="py-4 pr-6 pl-8 font-medium w-[18%]">{item.role}</td>
            <td className="py-4 px-6 font-medium w-[21%] ">
              {item.description}
            </td>
            <td className="py-4 px-6">{tenant.user.firstName}</td>
            <td className="py-4 px-6">
              <span
                className={`inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold ${
                  tenant.status === "Pending"
                    ? "bg-blue-100 text-blue-900"
                    : "bg-[#b8f4e8] text-[#17584b]"
                }`}
              >
                {tenant.status}
              </span>
            </td>
            <td className="py-4 px-6 text-[13px]">
              {formatDate(tenant.updatedAt)}
            </td>
            <td className="flex flex-flow-col gap-7 text-brand-500 py-3 px-7 text-[20px]">
              <div
                className="hover:bg-gray-300 rounded-full p-2"
                onClick={() => handleAssign(item._id)}
              >
                <FaUserLock size={20} />
              </div>
              <div
                className="hover:bg-gray-300 rounded-full p-2"
                onClick={() => handleEditClick(item)}
              >
                <MdEdit size={20} />
              </div>
              <div
                className="hover:bg-gray-300 rounded-full p-2"
                onClick={() => handleDeleteClick(item.id)}
              >
                <MdDelete size={20} />
              </div>
            </td>
          </tr>
        ))}
    </>
  );
};

export default RolesTd;
